import request from '@/utils/request';

export async function getSites(params) {
   return request.get('/sites', { params });
}

export async function getSofts(params) {
   return request.get('/softs', { params });
}